export default __webpack_public_path__ + "images/digger-b6f949d69a4f2f303270e093a0258da8.png";